// extracted by mini-css-extract-plugin
export var pillWrapper = "_pc-0";
export var showOverflow = "_pc-1";